import { create } from "zustand";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";

const useAuthStore = create((set) => ({
  user: null,
  isLoading: true,

  init: () => {
    onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        set({
          user: {
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            emailVerified: firebaseUser.emailVerified
          },
          isLoading: false
        });
      } else {
        set({ user: null, isLoading: false });
      }
    });
  },

  refreshEmailVerified: async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      await currentUser.reload();
      set((state) => ({
        user: {
          ...state.user,
          emailVerified: currentUser.emailVerified
        }
      }));
    }
  },

  logout: async () => {
    await auth.signOut();
    set({ user: null, isLoading: false });
  },
}));

export default useAuthStore;
